import React from 'react';
import { useTranslation } from '../contexts/TranslationContext';
import './CompletionModal.css';

/**
 * CompletionModal component
 * Shown when all uploads have settled (completed/failed/cancelled)
 */
function CompletionModal({ show, failedFiles, onUploadMore }) {
  const { t } = useTranslation();

  if (!show) return null;

  const handleUploadMore = () => {
    // Reload the page to start fresh
    window.location.reload();
  };

  return (
    <div className="completion-modal-overlay">
      <div className="completion-modal">
        <div className="completion-icon">&#10003;</div>
        <h2>{t('completionThankYou')}</h2>

        {failedFiles && failedFiles.length > 0 && (
          <div className="completion-failed">
            <p>{t('completionFailedIntro')}</p>
            <ul>
              {failedFiles.map((name, index) => (
                <li key={index}>{name}</li>
              ))}
            </ul>
          </div>
        )}

        <div className="completion-buttons">
          <button
            className="completion-btn completion-btn-upload"
            onClick={onUploadMore || handleUploadMore}
          >
            {t('completionUploadMore')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default CompletionModal;
